<template>
    <div class="list-entry my-1 col col-md-6">
        <b-skeleton width="90%"></b-skeleton>
    </div>
</template>

<script>
import { BSkeleton } from 'bootstrap-vue';
export default {
    name: 'ListEntryColumnSkeleton',
    components: {
        BSkeleton
    },
    props: {
        icon: {
            type: String,
            require: true
        },
        iconVariant: {
            type: String,
            default: 'fas'
        },
    }
}
</script>
